export default {
  path: 'outputInvoice',
  meta: {
    title: '销项发票'
  },
  component: () => import('@/components/parent-view'),
  name: 'outputInvoice',
  children: [
    {
      path: 'unbilled',
      meta: {
        title: '未开票销售订单'
      },
      name: 'unbilled',
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'outputInvoice-unbilled',
          meta: {
            title: '未开票销售订单'
          },
          component: () => import('@/view/v5/outputInvoice/unbilled/index.vue')
        },
        {
          path: '',
          name: 'outputInvoice-unbilled',
          meta: {
            title: '未开票销售订单'
          },
          component: () => import('@/view/v5/outputInvoice/unbilled/index.vue')
        },
        {
          path: 'detail',
          name: 'outputInvoice-unbilled-detail',
          meta: {
            title: '未开票销售订单详情'
          },
          component: () => import('@/view/v5/outputInvoice/unbilled/detail.vue')
        }
      ]
    },
    {
      path: 'apply',
      meta: {
        title: '开票申请'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'outputInvoice-apply',
          meta: {
            title: '开票申请'
          },
          component: () => import('@/view/v5/outputInvoice/apply/index.vue')
        },
        {
          path: 'detail',
          name: 'outputInvoice-apply-detail',
          meta: {
            title: '查看'
          },
          component: () => import('@/view/v5/outputInvoice/apply/detail.vue')
        },
        {
          path: 'add',
          name: 'outputInvoice-apply-add',
          meta: {
            title: '销项开票申请单'
          },
          component: () => import('@/view/v5/outputInvoice/apply/add.vue')
        }
      ]
    },
    {
      path: 'registration',
      meta: {
        title: '销项发票登记单'
      },
      name: 'registration',
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'outputInvoice-registration',
          meta: {
            title: '销项发票登记单'
          },
          component: () =>
            import('@/view/v5/outputInvoice/registration/index.vue')
        },
        {
          path: 'edit',
          name: 'outputInvoice-registration-edit',
          meta: {
            title: '编辑销项发票登记单'
          },
          component: () =>
            import('@/view/v5/outputInvoice/registration/edit.vue')
        },
        {
          path: 'detail',
          name: 'outputInvoice-registration-detail',
          meta: {
            title: '销项发票登记单详情'
          },
          component: () =>
            import('@/view/v5/outputInvoice/registration/detail.vue')
        }
      ]
    },
    {
      path: 'management',
      meta: {
        title: '销项发票管理'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'outputInvoice-management',
          meta: {
            title: '销项发票管理列表'
          },
          component: () =>
            import('@/view/v5/outputInvoice/management/index.vue')
        },
        {
          path: 'detail',
          name: 'outputInvoice-management-detail',
          meta: {
            title: '销项发票登记单详情'
          },
          component: () =>
            import('@/view/v5/outputInvoice/management/detail.vue')
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/v5/outputInvoice.js